import { request } from "../../../../services/api.ts"
import type {
  LeadLifecycleRequirement,
  LeadLifecycleRuleInput
} from "./lead-lifecycle.types.ts"

const BASE_URL = "/crm/lead-lifecycle-rules/"

interface RequirementsPayload {
  requirements: LeadLifecycleRequirement[]
}

// GET carries no write envelope, so the requirements array is the body itself.
export const getLeadLifecycleRules = () =>
  request.api.get<RequirementsPayload>(BASE_URL)

// PUT is a write, so the requirements array sits behind `details.data`.
export const saveLeadLifecycleRules = (requirements: LeadLifecycleRuleInput[]) =>
  request.api.put<{ details: { message?: string; data: RequirementsPayload } }>(
    BASE_URL,
    { requirements }
  )
